export default __webpack_public_path__ + "static/media/logo-us-oldnavy.a543355a.svg";